import { BaseClass } from '/src/components/BaseClass.js';
import { getSearchParam } from '/src/utils/pages.js';
import { removeSearchParam } from '/src/utils/location.js';
const slotStyle = new CSSStyleSheet();
slotStyle.replaceSync(`
 r-modal .content [data-modal-title] {
    font-size: 1.5rem;
    margin-bottom: 20px;
    font-weight: bold;
  }
`);
const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  :host {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: var(--color-block);
    width: 100dvw;
    height: 100dvh;
    z-index: 10000;
    display: none;
  }

  :host([open]) {
    display: flex;
  }

  ::slotted(.content) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .intrinsic {
    max-width: 700px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 14px;
    margin: 0 auto;

    & > * {
      width: 100%;
    }
  }

  .title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .top {
    margin-bottom: 10px;
  }

  .content {
    overflow: auto;
    flex-grow: 1;
    min-height: 0;
    margin: 0 auto;
    display: flex;
  }

  .footer {
    margin-top: 10px;
  }
`);
export class RModal extends BaseClass {
    query;
    title;
    constructor() {
        super();
        this.shadowRoot.adoptedStyleSheets.push(stylesheet);
        this.query = this.getAttribute('query');
        this.title = this.getAttribute('title');
    }
    get $contentArea() {
        return this.shadowRoot.querySelector('.content');
    }
    close() {
        this.dispatchEvent(new CustomEvent('close', { bubbles: true, composed: true }));
        this.removeAttribute('open');
        if (this.query)
            removeSearchParam(this.query);
        this.#disableBackButtonBehaviour();
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <div class="intrinsic">
        <div class="top">
          ${this.title ? `<div class="title">${this.title}</div>` : ''}
          <div class="header">
            <slot name="header"></slot>
          </div>
        </div>
        <div class="content">
          <slot></slot>
        </div>
       <div class="footer">
         <slot name="footer"></slot>
       </div>
     </div>
    `;
        const hasQueryInSearchParams = this.query && !!getSearchParam(this.query);
        if (hasQueryInSearchParams)
            this.open();
        this.#processClose();
        this.#addStylesToRootNode();
    }
    disconnectedCallback() {
        this.#disableBackButtonBehaviour();
    }
    open() {
        this.setAttribute('open', '');
        if (this.query) {
            const params = new URLSearchParams(location.search);
            params.set(this.query, 'true');
            history.pushState(undefined, '', `${location.pathname}?${params}`);
        }
        else {
            history.pushState(undefined, '', location.pathname);
        }
        this.#enableBackButtonBehaviour();
    }
    #backButtonCallback = (e) => {
        if (!e.userInitiated || e.destination.index >= this.#currentEntryIndex)
            return;
        this.close();
    };
    #currentEntryIndex;
    #addStylesToRootNode() {
        const adoptedStylesheets = this.getRootNode().adoptedStyleSheets;
        if (!adoptedStylesheets)
            this.getRootNode().adoptedStyleSheets = [slotStyle];
        else
            this.getRootNode().adoptedStyleSheets.push(slotStyle);
    }
    #disableBackButtonBehaviour() {
        navigation.removeEventListener('navigate', this.#backButtonCallback);
    }
    #enableBackButtonBehaviour() {
        this.#currentEntryIndex = navigation.currentEntry.index;
        navigation.addEventListener('navigate', this.#backButtonCallback);
    }
    #processClose() {
        [...this.shadowRoot.querySelectorAll('slot')].forEach($s => {
            $s.assignedElements().forEach($el => {
                $el.querySelectorAll('[data-close-trigger]').forEach($elm => {
                    $elm.addEventListener('click', this.close.bind(this));
                });
            });
        });
    }
}
customElements.define('r-modal', RModal);
